import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import {
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";
import { addAutoAtendimentoCliente } from "slices/Empresa/thunk";
import * as Yup from "yup";
import withRouter from "../../Components/Common/withRouter";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

const Cliente = () => {
  document.title = "Fila de atendimento :: Cliente";
  const dispatch: any = useDispatch();

  const validationSchema = Yup.object({
    nome: Yup.string()
      .required("Nome é obrigatório !")
      .max(255, "Nome deve ter no mínimo 255 caracteres !"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      nome: "",
    },
  });

  const onSubmit = async (data: any) => {
    const result = await dispatch(addAutoAtendimentoCliente(data));
    if (result.payload.name === undefined) {
      reset({
        nome: "",
      });
    }
  };

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="flex-grow-1" style={{ textAlign: "center" }}>
          <h2>Controle de atendimento</h2>
        </div>
        <div className="page-content landing" style={{ paddingTop: 50 }}>
          <Container fluid>
            <Form
              noValidate
              autoComplete="off"
              className="tablelist-form"
              onSubmit={handleSubmit(onSubmit)}
            >
              <Row className="mb-3">
                <Col lg={4}></Col>
                <Col lg={4}>
                  <Label for="nome" className="form-label">
                    Auto atendimento
                  </Label>
                  <Controller
                    name="nome"
                    control={control}
                    render={({ field }) => (
                      <Input
                        {...field}
                        maxLength={255}
                        type="text"
                        className="form-control"
                        value={field.value || ""}
                        onChange={(e) => field.onChange(e.target.value)}
                        invalid={!!errors.nome}
                        placeholder="Insira o nome da sua empresa"
                      />
                    )}
                  />
                  {errors.nome && (
                    <FormFeedback>{errors.nome.message}</FormFeedback>
                  )}
                </Col>
              </Row>
              <Row>
                <div className="hstack justify-content-center">
                  <button
                    type="submit"
                    className="btn btn-success"
                    id="add-btn"
                  >
                    Salvar
                  </button>
                </div>
              </Row>
            </Form>
          </Container>
          <ToastContainer closeButton={false} limit={1} />
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(Cliente);
